<template>
  <div>

    <v-tooltip v-if="displayAsFab" right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="success"
          v-on="on"
          @click.stop="showPdfDialog = true; getPdf()"
        >
          <v-icon dark left>picture_as_pdf</v-icon>
          <span>Générer le PDF</span>
        </v-btn>
      </template>
      <span>Générer le PDF</span>
    </v-tooltip>

    <v-tooltip v-else right>
      <template v-slot:activator="{ on }">
        <v-btn
          block
          color="success"
          dark
          v-on="on"
          @click.stop="showPdfDialog = true; getPdf()"
        >
          <v-icon dark left>picture_as_pdf</v-icon>
          <span>Générer le PDF</span>
        </v-btn>
      </template>
      <span>Générer le PDF</span>
    </v-tooltip>


    <v-dialog persistent lazy v-model="showPdfDialog" width="800px">

      <v-card >

        <v-layout align-end justify-end>
          <v-btn icon @click="showPdfDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
        <v-layout
          v-if="!pdfRequestError"
          row wrap
        >
          <v-flex xs12 text-xs-center>
            <v-progress-circular
              :size="70"
              :width="7"
              color="purple"
              indeterminate
            ></v-progress-circular>
            <v-layout align-center justify-center>
              <v-card-title primary-title>
                <div>
                  <h5 class="headline">Génération de votre PDF.</h5>
                  <span class="subheading"> Veuillez patientez... </span>
                </div>
              </v-card-title>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout
          v-else
          row wrap
        >
          <v-flex xs12>
            <v-layout align-center justify-center>
              <v-card-title primary-title>
                <v-alert
                  :value="true"
                  type="warning"
                >
                  <h3 class="headline ">Une Erreur s'est produite.</h3>
                  Veuillez nous en excuser et ré-essayer ultérieurement.
                </v-alert>
              </v-card-title>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>

    </v-dialog>

  </div>
</template>

<script>
 /*
    L'état du v-dialog est géré par vuex.
    Ainsi, plusieurs components peuvent intéragir avec celui-ci.
  */


 import session from '../api/session';
 import { saveAs } from 'file-saver';
 import { mapGetters } from 'vuex';

 export default {
   props: {
     cvid: String,
     displayAsFab: Boolean,
   },
   data: function() {
     return {
       showPdfDialog: false,
       modelObject: {},
       pdfRequestError: false,
       isLoading: false,
       fullPage: true,
       pdf_url: '/api/cv/' + this.cvid + '/create_the_pdf',
       django_pdf_url: '/api/cv/' + this.cvid + '/create_pdf',
       img: null,
     }
   },
   computed: {
     ...mapGetters('cvVuex', [
       'getCvName',
     ]),
   },
   methods : {
     getPdf() {
       this.pdfRequestError = false
       // voir CvPreviewNew.vue pour l'explication de randomNum
       var randomNum = Math.random();
       session.get(this.django_pdf_url, {timeout: 30000, responseType: 'blob'},)
              .then((response) => {
                /*
                   Astuce pour récupérer la pièce jointe
                   https://gist.github.com/javilobo8/097c30a233786be52070986d8cdb1743 */

                /* const url = window.URL.createObjectURL(new Blob([response.data]));
                 * const link = document.createElement('a');
                 * link.href = url;
                 * link.setAttribute('download', 'votre-cv.pdf');
                 * document.body.appendChild(link);
                 * this.showPdfDialog = false;
                 * link.click(); */

                // nommage du fichier pdf
                var pdf_name = 'votre_cv.pdf'
                var cv_name = this.getCvName
                console.log('\n\n\n\n**********' + cv_name)

                if(cv_name != 'Nouveau CV') {
                  pdf_name = cv_name+'.pdf'
                }

                // Téléchargement du pdf sur le poste client.
                saveAs(response.data, pdf_name);
                this.showPdfDialog = false;

              })
              .catch((err) => {
                this.isLoading = false;
                this.pdfRequestError = true;
                if (err.response) {
                  // The request was made and the server responded with a status code
                  // that falls out of the range of 2xx
                  console.log('======= getPreview error in response =======')
                  console.log(err.response.data);
                  console.log(err.response.status);
                  console.log(err.response.headers);
                } else if (err.request) {
                  // The request was made but no response was received
                  // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                  // http.ClientRequest in node.js
                  console.log('======= getPreview error in request =======')
                  console.log(err.request);
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log('======= getPreview error in else =======')
                  console.log('Err', err.message);
                }
              })

     },

   },

 }
</script>
